
export const getResponsivePadding = (isMobile, isTab, mobileValue, tabValue, desktopValue) => {
  if (isMobile) return mobileValue;
  if (isTab) return tabValue;
  return desktopValue;
};


export const calculatePaddingTopBottom = (isMobile, isTab) => {
  if (isMobile) return '0.2vh';
  if (isTab) return '0.3vh';
  return '0.4vh';
};


export const calculatePaddingLeftRight = (isMobile, isTab) => {
  if (isMobile) return '0.4vh';
  if (isTab) return '0.6vh';
  return '0.8vh';
};


export const calculateFontSize = (isRecorder, isMobile, isTab, isPortrait) => {
  if (isRecorder) {
    return isMobile && isPortrait ? '2.4vh' : '1.2vh';
  }
  if (isMobile) return '1.2vh';
  if (isTab) return '1.4vh';
  return '1.6vh';
};


export const calculateIconPadding = (isActiveSpeaker, isMobile, isTab) => {
  if (isActiveSpeaker) return '0vh';
  if (isMobile) return '0.2vh';
  if (isTab) return '0.3vh';
  return '0.1vh';
};


export const calculateButtonPadding = (isMobile, isTab) => {
  if (isMobile) return '0.3vh';
  if (isTab) return '0.4vh';
  return '0.5vh';
};


export const calculatePosition = (show, isMobile, isTab, visibleMobile, visibleTab, visibleDesktop, hiddenValue) => {
  if (!show) return hiddenValue;
  if (isMobile) return visibleMobile;
  if (isTab) return visibleTab;
  return visibleDesktop;
};


export const PARTICIPANT_CONTAINER_PADDING = {
  paddingTop: '0.4vh',
  paddingBottom: '0.4vh',
  paddingRight: '0.4vh',
  paddingLeft: '0.4vh',
};


export const PARTICIPANT_CONTAINER_SIZE = {
  height: `calc(100% - 0.8vh)`,
  width: `calc(100% - 0.8vh)`,
};


export const LAYOUT_GUTTER = 0.4;


export const calculateAnalyzerSize = (analyzerSize, isRecorder, isMobile, isPortrait) => {
  const baseSize = (analyzerSize * 2) / 3 * 0.1;
  if (isRecorder && isMobile && isPortrait) {
    return `${baseSize * 2}vh`;
  }
  return `${baseSize}vh`;
};


export const CONFIG_CARD_BOX_STYLES = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  gap: '1vh',
};


export const CONFIG_CARD_ICON_CONTAINER = {
  width: '12.5vh',
  height: '8vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '0.6vh',
  border: '0.2vh solid #70707033',
  padding: '0.6vh',
};


export const CONFIG_CARD_ICON_INNER = {
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};


export const CONFIG_CARD_TYPOGRAPHY_STYLES = {
  fontSize: '1.6vh',
};


export const CONFIG_SECTION_CONTAINER = {
  display: "flex",
  flexDirection: "column",
  gap: '1.2vh',
};


export const CONFIG_SECTION_HEADING = {
  fontWeight: 600,
  lineHeight: '1.6vh',
  fontSize: '1.8vh',
};


export const CONFIG_CARD_GRID = {
  display: "flex",
  gap: '1.2vh',
  flexWrap: 'wrap',
};


export const CONFIG_PANEL_CONTAINER = {
  display: "flex",
  flexDirection: "column",
  gap: '1.2vh',
  padding: '0.8vh',
};


export const CONFIG_SLIDER_CONTAINER = {
  paddingLeft: '1vh',
  paddingRight: '1vh',
};
